<template>
  <!-- BOUTON DECONNECTER -->
  <a :class="buttonClass" tabindex="0">
    <IneaIcone
      :name="iconName"
      :color="iconColor"
      :comment="comment"
      size="sm"
      role="button"
      aria-expanded="false"
    />
    {{ text }}
  </a>
</template>

<script>
import IneaIcone from "@clir/IneaIcone/IneaIcone";
export default {
  name: "ApplicationHeaderButton",
  props: {
    buttonConfig: { type: Object, default: () => {} }
  },
  computed: {
    buttonClass() {
      return `${this.prefixStringKey(this.buttonConfig, "buttonClass", {
        prefix: "btn btn-auth ms-1_4 text-xs fw-bold ",
        defaut: "btn btn-auth ms-1_4 text-xs fw-bold"
      })} ${this.prefixStringKey(this.buttonConfig, "buttonColor", {
        prefix: "btn-"
      })}`;
    },
    text() {
      return this.getKey(this.buttonConfig, "text", "");
    },
    comment() {
      return this.getKey(this.buttonConfig, "comment", this.text);
    },
    iconName() {
      return this.getKey(this.buttonConfig, "iconName", "");
    },
    iconColor() {
      return this.getKey(this.buttonConfig, "iconColor", "");
    }
  },
  components: {
    IneaIcone
  }
};
</script>